<template>
  <div class="rule-waiting-list-view flex flex-col gap-4 py-5">
    <p class="m-0 max-w-3xl text-sm text-muted-foreground">
      {{ tr('Here you can see the contents on the waiting list that require attention due to rules or advertising policy issues. Click on individual items for detailed information. You can approve or reject activities, or override AI decisions.') }}
    </p>

    <rule-waiting-list-content :rule="rule" is-rule-specific />
  </div>
</template>

<script>
import RuleWaitingListContent from '@/ui/components/RuleWaitingListContent.vue';

export default {
  name: 'RuleWaitingListView',
  components: {
    RuleWaitingListContent,
  },
  inject: [ 'ruleView' ],
  computed: {
    rule() {
      return this.ruleView.rule;
    },
  },
};
</script>
